import { createReducer } from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { all } from 'redux-saga/effects'
import { Entity } from '~/utils/entity-utils'
import { __ } from '~/i18n'

import API from '~/api'

const entityName = 'product';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}

export const reducer = createReducer(entity.reducer, {});

export const STATE_ACTIVE = 'active';
export const STATE_HIDDEN = 'hidden';
export const STATE_DELETED = 'deleted';

export const states = {
  STATE_ACTIVE,
  STATE_HIDDEN,
  STATE_DELETED
};

export const getStateChoices = () => {
  return [
    {value: STATE_ACTIVE, label: __('Active'), text: __('Active')},
    {value: STATE_HIDDEN, label: __('Hidden'), text: __('Hidden')},
  ]
};


export default {
  actions,
  workers,
  saga,
  reducer
}
